import React, { useState, useEffect, Suspense, Fragment } from "react";
import { useParams, useLocation } from "react-router-dom";
import config from "./../../../config/config.json";
import ContentLoader from "react-content-loader";
import { IconButton, Collapse, Alert, Grid, Skeleton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingSkeletonModule from "./../../common/LoadingSkeletonModule";

const DashboardCardExpanded = () => {
  const [open, setOpen] = useState(true);
  const [statusLogin, setStatusLogin] = useState(false);
  const [card, setCard] = useState(null);

  const { card: cardParam } = useParams(); // Get the route parameter
  const location = useLocation(); //   Get location status

  useEffect(() => {
    const updateCard = async () => {
      const cardRoutingRaw = cardParam !== 'login' ? cardParam : 'guide-portal';
      const cardRouting = cardRoutingRaw === 'accounts' ? 'account' : cardRoutingRaw;
      const cardFilter = config.cards.filter(e => e.routing === cardRouting);
      setStatusLogin(false);
      setCard(cardFilter[0] || null);
    };

    updateCard();
  }, [cardParam]);

  const collapseAlert = () => {
    setOpen(!open);
  };

  const getAlertComponents = () => (
    <>
      {location.state?.responseDelete && (
        <Collapse in={open}>
          <Alert
            severity="info"
            variant="filled"
            className="alert-info mb-3"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={collapseAlert}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {location.state.responseDelete}
          </Alert>
        </Collapse>
      )}
      {location.state?.responseCreate && (
        <Collapse in={open}>
          <Alert
            severity="info"
            variant="filled"
            className="alert-info mb-3"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={collapseAlert}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {location.state.responseCreate}
          </Alert>
        </Collapse>
      )}
      {location.state?.responseEdit && (
        <Collapse in={open}>
          <Alert
            severity="info"
            variant="filled"
            className="alert-info mb-3"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={collapseAlert}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {location.state.responseEdit}
          </Alert>
        </Collapse>
      )}
    </>
  );

  const dashboardCardType = () => {
    if (!card?.config?.type) return null;
    const Component = React.lazy(() =>
      import(`./sections/DashboardCard${card?.config?.type}`)
    );
    return (
      <Suspense
        fallback={
          <LoadingSkeletonModule />
        }
      >
        <Component data={card} className={card?.config?.type} />
      </Suspense>
    );
  };

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item md={12}>
          <div className={`detail_dashboard dashboard_card_expanded DashboardCardViews ${card}`}>
            <div className="content_detail_dashboard">
              {getAlertComponents()}
              {dashboardCardType()}
            </div>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default DashboardCardExpanded;
